// 统一请求路径前缀在commmon/axios.js中修改
import { postDemo,getDemo,deleDemo,deleDemos,getRequest, postRequest,postRequestLogin,putRequest,putNoToken,getRequestWithNoToken } from '../assets/js/api';

// 注册账户
export const _register = (params) => {
  return getRequestWithNoToken('/users​/api-system​/users​/register', params)
}

// 获取验证码
export const _getCode = (params) => {
  return getRequestWithNoToken('/users/api-syste/users/getCode', params)
}
/**
 * 首页积极养育课中获取推荐和精选
 * @param {*tag} string 家长 儿童区分
 * @param {*asc} boolean
 * @param {*currentPage} integer 当前页数
 * @param {*orderByField} string 排序字段
 * @param {*pageSize} integer 每页显示记录数量
 * @param {*queryData} Object 
 * @param {*queryData} Object 【handpick:boolean,recommend:boolean,top:boolean,contentTypeList:[ AUDIO, FILE, PICTURE, VIDEO ]】
 */
export const _getCourseList = (params) => {
    return postRequest('/api-content/content/contents/putaway', params)
}
/**
 * 根据栏目层级列出栏目
 * @param {*columnLayer} string  一级栏目, 三级栏目, 二级栏目
 * @param {*page} integer 当前页数
 * @param {*limit} integer 每页多少条
 */
 export const _getColumnLayer = (params) => {
  return getRequest('/api-content/column/columns/layer', params)
}

/**
 * 列出分支栏目
 * @param {*fatherId } string
 */
 export const _getColumnBranch = (params) => {
  return getRequest('/api-content/cms/column/branches', params)
}

/**
 * 获取用户收藏的内容
 * @param {*fatherId } string
 */
 export const _getUserConcerned = (params) => {
  return postRequest('/api-content/content/content/concerned', params)
}

// 获取用户已购买的内容
export const _queryIsPayed = (params) => {
  return postRequest('/api-content/content/contents/queryIsPayed', params)
}

// 获取课程下面的内容
export const course = (params) => {
  return postRequest('/api-content/content/contents/course', params)
}

// 获取课程详情
export const courseView = (params) => {
  return getRequest('/api-content/course/view/' + params)
}


/**
 * 列出栏目下的内容
 * @param {*asc } Boolean
 * @param {*currentPage } number
 * @param {*orderByField } string
 * @param {*pageSize } number
 * @param {*queryData } Array　"tag": "string"　家长　儿童　数组内传递
 */
 export const _getColumnContents = (params) => {
  return postRequest('/api-content/content/contents/column', params)
}

/**
 * 用户收藏内容
 * @param {*contentId } string
 * @param {*cuserId } string
 */
 export const _userAttention = (params) => {
  return postRequest('/api-content/content/content/attention', params)
}

/**
 * 查询用户是否收藏内容
 * @param {*contentId  } string
 */
 export const _julyAttention = (params) => {
  return getRequest('/api-content/content/content/attention', params)
}

/**
 * 用户取关内容
 * @param {*contentId  } string
 * @param {*cuserId  } string
 */
 export const _delAttention = (params) => {
  return deleDemos('/api-content/content/content/attention', params)
}

/**
 * 保存用户搜索历史
 * @param {*text } string
 */
 export const _saveSearchHistory = (params) => {
  return postRequest('/api-content/content/search-history', params)
}

/**
 * 获取用户搜索历史
 * @param {*text } string
 */
 export const _getSearchHistory = (params) => {
  return getRequest('/api-content/content/search-history', params)
}

/**
 * 批量删除搜索历史
 * @param {*contentId  } string
 * @param {*cuserId  } string
 */
 export const _delSearchHistory = (params) => {
  return deleDemos('/api-content/content/search-history', params)
}

// /**
//  * 列出更多相关视频
//  * @param {*text } string
//  */
//  export const _moreCorrelation = (params) => {
//   return postDemo('/api-content/content/contents/correlation', params)
// }

/**
 * 列出更多相关视频
 * 
 * @param {*asc } false
 * @param {*currentPage }  0
 * @param {*orderByField } string
 * @param {*pageSize } 0
 * @param {*queryData } Array  description: string title: string
 */
 export const _moreCorrelationPlus = (params) => {
  return postRequest('/api-content/content/contents/correlation/plus', params)
}

/**
 * 开心空间，列出栏目下的课程
 * @param {*text } string
 */
 export const _courseColumn = (params) => {
  return postRequest('/api-content/course/courses/column', params)
}

/**
 * 接收消息接口
 * @param No
 */
 export const _getMessageReceive = (params) => {
  return postRequest('/api-message/message/receive', params)
}

/**
 * 栏目下更多视频推荐
 * @param {*text } string
 */
 export const _moreCorrelation = (params) => {
  return postRequest('/api-content/content/contents/correlation', params)
}

/**
 * 新增积分
 * @param {*businessId } string 文章/视频id
 * @param {*name} string 文章/视频名称
 * @param{*type} integer 类型： 2文章 3视频
 */
 export const _addIntegral = (params) => {
  return postRequest('/api-customer-c/integral/addIntegral', params)
}

/**
 * 该视频当日是否看过
 * @param {*businessId } string 文章/视频id
 * @param {*userId  } string 用户id
 */
 export const _checkUserWatch = (params) => {
  return getRequest('/api-customer-c/integral/checkUserWatch', params)
}

/**
 * 获取下一条视频
 * @param {*columnId } string 栏目id
 * @param {*nowContentId  } string 视频id
 * @param {*isMark  } integer 是否是收藏栏目
 * @param {*isPick  } integer 是否是精选栏目
 * @param {*isRecommend  } integer 是否是推荐栏目
 */
 export const _nextVideo= (params) => {
  return getRequest('/api-content/content/next', params)
}

/**
 * 用户标记看视频时非wifi情况下免提醒
 * @param no params
 */
 export const _wifiStatusPost = (params) => {
  return postRequest('/api-content/api/v1/content/manager/wifi', params)
}

/**
 * 用户标记看视频时非wifi情况下免提醒
 * @param no params
 */
 export const _wifiStatusGet = (params) => {
  return getRequest('/api-content/api/v1/content/manager/wifiStatus', params)
}

/**
 * 加载栏目下的内容列表或者栏目列表
 * @param *code 家长儿童标签
* @param *columnId  栏目id
 */
 export const _columnListDeatil= (params) => {
  return getRequest('/api-content/column/list/details', params)
}
/**
 * 判断当前栏目下是否存在视频,或者文章,或者课程
* @param *columnId  栏目id
 */
export const _existContents= (params) => {
  return getRequest('​/api-content/column/exist/contents', params)
}

// 根据id获取详情
export const _detail = (params) => {
  return postRequest('/api-content/content/detail', params)
}


